import { userConstants } from "../../constants/ActionTypes";

const initialState = {
    page : 1,
    limit : 30,
    totalPage : 0,
    TransactionList : [],
    open_picker : false,
    startDate : new Date(),
    endDate : new Date(),
    from: "",
    to: "",
    fromDate:  "",
    toDate: "",
    isTransDetail: false,
    TransactionDetail: {},
    disabled_page:true,
    virtualAccountList:[],
    van_account_no:"",
    searchTerm:"",
    status:"",
    is_scheduled:false,
    is_scheduled_label:"",
    is_product_value:"",
    is_product_label:"",
};

export function account_statement(state = initialState, action) {
    switch (action.type) {  
        case userConstants.ACCOUNT_STATEMENT:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}